import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { Text } from "@pentabd/ui";

import { SelectController } from "./SelectController";

import {
  OnChangeType,
  OptionType,
  RenderType,
  SelectionType,
} from "@pentabd/ui/build/atoms/select/types";

interface SelectRowType {
  label: string;
  required?: boolean;
  register: any;
  name: string;
  control: any;
  placeholder?: string;
  setValue: any;
  status?: "primary" | "secondary" | "danger" | "warning" | "success" | "info";
  size?: "xs" | "sm" | "md" | "lg" | "xl";
  options: OptionType[];
  isMulti?: boolean;
  isSearchable?: boolean;
  isClearable?: boolean;
  onChange?: OnChangeType;
  suffix?: JSX.Element | JSX.Element[] | string;
  prefix?: JSX.Element | JSX.Element[] | string;
  stablePrefix?: boolean;
  stableSuffix?: boolean;
  disabled?: boolean;
  renderSelected?: RenderType;
  value?: string | number | string[];
  defaultValue?: string | number | string[];
  onSelectItem?: (data: SelectionType) => void;
  portal?: boolean;
  minWidth?: boolean;
  emptyMessage?: string;
  error?: any;
  selectAction?: (e: number) => void;
  cols?: 2 | 3 | 4 | 6;
  withoutLabel?: boolean;
}

export const SelectControllerVertical = ({
  register,
  name,
  label,
  required,
  control,
  error,
  placeholder,
  disabled,
  options,
  setValue,
  selectAction,
  portal = false,
  cols,
  withoutLabel,
  isSearchable,
}: SelectRowType) => {
  const { t } = useTranslation();

  return (
    <div
      className={classNames("col-12", {
        "col-xl-4 col-2xl-2": cols === 2,
        "col-xl-4 col-2xl-3": cols === 3,
        "col-xl-4": cols === 4,
        "col-sm-6": cols === 6,
      })}
    >
      {!withoutLabel && (
        <Text
          weight="semibold"
          color="title"
          size="sm"
          component="p"
          className="mb-3"
        >
          {t(`${label}.LABEL`)}
          {required && <span className="text-danger">&#42;</span>}
        </Text>
      )}
      <SelectController
        disabled={disabled}
        placeholder={t(placeholder ? placeholder : `${label}.PLACEHOLDER`)}
        control={control}
        name={name}
        register={register}
        options={options}
        setValue={setValue}
        error={error}
        portal={portal}
        selectAction={selectAction}
        isSearchable={isSearchable}
      />
    </div>
  );
};
